import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../header/header";
import Sidebar from "../sidebar/sidebar";
import Loader from "../loader/loader";
import { useProducts } from "../../pages/products/hooks";
import "./layout.css";

const SIDEBAR_COLLAPSED_KEY = "sidebar-collapsed";

const Layout: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(() => {
    // Initialize from localStorage on first render
    const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    return saved ? JSON.parse(saved) : false;
  });
  const { products, fetchProducts } = useProducts();

  // Save to localStorage whenever the state changes
  useEffect(() => {
    localStorage.setItem(
      SIDEBAR_COLLAPSED_KEY,
      JSON.stringify(isSidebarCollapsed)
    );
  }, [isSidebarCollapsed]);

  return (
    <div className="layout">
      <Header products={products} onProductsUpdate={fetchProducts} />
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        setIsCollapsed={setIsSidebarCollapsed}
      />
      <div className="layout__content">
        <main
          className={`layout__main ${
            isSidebarCollapsed ? "layout__main--sidebar-collapsed" : ""
          }`}
        >
          <Outlet />
        </main>
      </div>
      <Loader />
    </div>
  );
};

export default Layout;
